import { FullStory, init, isInitialized } from '@fullstory/browser';

export const initializeFullStory = (orgId: string, devMode: boolean): void => {
  if (!isInitialized()) {
    init({ orgId, devMode });
  }
};

export const trackFullStoryEvent = (name: string, properties: object = {}): void => {
  if (!isInitialized()) {
    return;
  }
  FullStory('trackEvent', { name, properties });
};

export const identifyFullStoryUser = (userSlug: string, properties: object): void => {
  FullStory('setIdentity', { uid: userSlug, properties });
};

export const anonymizeFullStoryUser = (): void => {
  FullStory('setIdentity', { anonymous: true });
};

export interface FullStoryUserProperties {
  org_type: string;
  role: string;
  account_age_days: number;
  account_tier: string;
  feature_flags: object;
}

const MS_PER_DAY = 1000 * 60 * 60 * 24;

export const formatFullStoryUserProperties = (
  user: User,
  featureFlags: object,
  now: Date = new Date()
): FullStoryUserProperties => {
  const accountAgeDays = Math.floor((now.getTime() - new Date(user.accountCreatedAt).getTime()) / MS_PER_DAY);

  return {
    org_type: user.accountType,
    role: user.roles[0],
    account_age_days: accountAgeDays,
    account_tier: user.tierName,
    feature_flags: featureFlags,
  };
};
